import ProductListContainer from "../../Componant/Ecommerce/ProductList";

const ProductList = () => {
  return (
    <div className="page-body">
      <ProductListContainer />
    </div>
  );
};

export default ProductList;
